import { createReducer } from '@reduxjs/toolkit';

import * as legacyRecords from 'state/records/types';

export enum EventState {
  IDLE = 'IDLE',
  STARTED = 'STARTED',
}

export const initialState = {
  status: EventState.IDLE,
};

const reducer = createReducer(initialState, {
  [legacyRecords.INITIALIZED]: () => ({ status: EventState.STARTED }),
  [legacyRecords.ENDED]: () => ({ status: EventState.IDLE }),
});

export default reducer;
